import { MarkerClusterer } from '@googlemaps/markerclusterer';
import { initGoogleMapsAutocomplete } from '@jspartials/google-maps-autocomplete-utils';
import {
  listenDOMEvent,
  createElement,
  appendElementContent
} from '@jspartials/dom-api-utils';
import {
  classes,
  addClassToElement,
  removeClassToElement
} from '@jspartials/class-list-utils';
import { pushOnDataLayer } from '@jspartials/gtm-utils';

const parser = new DOMParser();

// Icons
const iconMarkerStoreString =
  '<svg width="30px" height="40px" viewBox="0 0 62 85" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><polygon id="path-1" points="0 0 26 0 26 25 0 25"></polygon><polygon id="path-3" points="0 0 26 0 26 25 0 25"></polygon></defs><g id="RESERVAR-CITA" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="iconos-localizador-tiendas" transform="translate(-73.000000, -99.000000)"><g transform="translate(73.000000, 99.000000)"><path d="M30.6642311,85 C29.9381006,85 29.1195532,84.4969506 28.2085888,83.4908518 C14.9057776,66.304088 6.21643831,52.360435 2.14057086,41.6598928 C-3.97323032,25.6090796 2.25436056,0 30.6642311,0 L30.4343599,0 C58.8442305,0 65.0718214,25.6090796 58.9580202,41.6598928 C54.8821528,52.360435 46.1928134,66.304088 32.8900023,83.4908518 C31.9790379,84.4969506 31.1604904,85 30.4343599,85" id="Path-Copy" fill="#000000"></path><g transform="translate(14.000000, 16.000000)"><g transform="translate(7.000000, 0.000000)"><mask id="mask-2" fill="white"><use xlink:href="#path-1"></use></mask><g id="Clip-2"></g><path d="M20.2409255,0 L26.0004136,0 L26.0004136,25.0001822 L18.6817042,25.0001822 L18.6817042,16.240613 L12.4826328,16.240613 C8.55887814,16.240613 3.92434548,16.2393983 0,16.2321098 L0.00295418961,14.6292459 C3.92611799,14.6365344 8.56005981,14.6377491 12.4826328,14.6377491 L20.2409255,14.6377491 L20.2409255,23.3973183 L24.4411923,23.3973183 L24.4411923,1.6028639 L20.2409255,1.6028639 L20.2409255,0 Z" id="Fill-1" fill="#FFFFFF" mask="url(#mask-2)"></path></g><g id="Group-6"><mask id="mask-4" fill="white"><use xlink:href="#path-3"></use></mask><g id="Clip-5"></g><polygon id="Fill-4" fill="#FFFFFF" mask="url(#mask-4)" points="0 0 7.27971791 0 7.27971791 8.63930886 26 8.63930886 26 10.2421728 5.7288036 10.2421728 5.7288036 1.6028639 1.55091431 1.6028639 1.55091431 23.3973183 5.79815104 23.3973183 5.79815104 25.0001822 0 25.0001822"></polygon></g></g></g></g></g></svg>';
const iconMarkerStoreWithOpticsString =
  '<svg width="30px" height="40px" viewBox="0 0 62 85" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><polygon id="path-2" points="0 0 26 0 26 25 0 25"></polygon><polygon id="path-4" points="0 0 26 0 26 25 0 25"></polygon></defs><g id="RESERVAR-CITA" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="iconos-localizador-tiendas2" transform="translate(-165.000000, -99.000000)"><g id="Group2" transform="translate(165.000000, 99.000000)"><path d="M30.6642311,85 C29.9381006,85 29.1195532,84.4969506 28.2085888,83.4908518 C14.9057776,66.304088 6.21643831,52.360435 2.14057086,41.6598928 C-3.97323032,25.6090796 2.25436056,0 30.6642311,0 L30.4343599,0 C58.8442305,0 65.0718214,25.6090796 58.9580202,41.6598928 C54.8821528,52.360435 46.1928134,66.304088 32.8900023,83.4908518 C31.9790379,84.4969506 31.1604904,85 30.4343599,85" id="Path-Copy-3" fill="#2946F1"></path><g id="Group-7-Copy-3" transform="translate(14.000000, 16.000000)"><g id="Group-5" transform="translate(7.000000, 0.000000)"><mask id="mask-3" fill="white"><use xlink:href="#path-2"></use></mask><g id="Clip-2"></g><path d="M20.2409255,0 L26.0004136,0 L26.0004136,25.0001822 L18.6817042,25.0001822 L18.6817042,16.240613 L12.4826328,16.240613 C8.55887814,16.240613 3.92434548,16.2393983 0,16.2321098 L0.00295418961,14.6292459 C3.92611799,14.6365344 8.56005981,14.6377491 12.4826328,14.6377491 L20.2409255,14.6377491 L20.2409255,23.3973183 L24.4411923,23.3973183 L24.4411923,1.6028639 L20.2409255,1.6028639 L20.2409255,0 Z" id="Fill-1" fill="#FFFFFF" mask="url(#mask-3)"></path></g><g id="Group-7"><mask id="mask-5" fill="white"><use xlink:href="#path-4"></use></mask><g id="Clip-5"></g><polygon id="Fill-4" fill="#FFFFFF" mask="url(#mask-5)" points="0 0 7.27971791 0 7.27971791 8.63930886 26 8.63930886 26 10.2421728 5.7288036 10.2421728 5.7288036 1.6028639 1.55091431 1.6028639 1.55091431 23.3973183 5.79815104 23.3973183 5.79815104 25.0001822 0 25.0001822"></polygon></g></g></g></g></g></svg>';

const iconMarkerStore = parser.parseFromString(
  iconMarkerStoreString,
  'image/svg+xml'
).documentElement;

const iconMarkerStoreWithOptics = parser.parseFromString(
  iconMarkerStoreWithOpticsString,
  'image/svg+xml'
).documentElement;

// Selectors
const selector = {
  isVisibleMap: 'is-visible-map',
  isVisibleList: 'is-visible-list',
  stores: '.js-stores',
  map: '.js-map',
  storeDetails: '.js-store-details',
  searcherMap: '.js-searcher-map',
  buttonGeolocation: '.js-button-geolocation',
  checkboxFilterOptics: '.js-checkbox-filter-optics',
  tabButton: '.js-input-tab',
  suggestions: {
    wrapper: '.js-suggested-addresses',
    list: '.js-suggested-addresses__list'
  }
};

// Elements
const element = {
  page: document.querySelector(selector.stores) || null,
  mapCanvas: document.querySelector(selector.map) || null,
  storeDetailsElements: document.querySelectorAll(selector.storeDetails) || [],
  searcherMap: document.querySelector(selector.searcherMap) || null,
  buttonGeolocation: document.querySelector(selector.buttonGeolocation) || null,
  checkboxOptics: document.querySelector(selector.checkboxFilterOptics) || null,
  tabButtons: document.querySelectorAll(selector.tabButton) || [],
  suggestions: {
    wrapper: document.querySelector(selector.suggestions.wrapper) || null,
    list: document.querySelector(selector.suggestions.list) || null
  }
};

// Variables
const VALUE_FOR_TAB_MAP = 'map';
const VALUE_FOR_TAB_LIST = 'list';
const enterKey = 'Enter';
let map, infoWindow, markerCluster, delay;
let markers = [];
let Map = null;
let AdvancedMarkerElement = null;
let Place = null;
let InfoWindow = null;
const requestAutocomplete = {
  input: '',
  sessionToken: '',
  includedPrimaryTypes: ['geocode']
};
let AutocompleteSessionToken = null;
let AutocompleteSuggestion = null;
let selectedIndexForSuggestionsList = 0;
const urlParameter = {
  storeId: 'id',
  filterOptics: 'optical'
};
const initialLocationForMap = { lat: 40.416775, lng: -3.70379 }; // Madrid
const minCharactersForAutocomplete =
  globalVariables.googleMaps.minCharactersForAutocomplete;
let debounceTimer = null;
const debounceDelay = 600;
let lastSearchedValueForAutocomplete = '';
let currentSuggestions = [];
let lastPrediction = null;
const sessionAutocomplete = {
  token: null,
  closed: false
};

// Functions

/**
 * Initialize map and its dependencies and set the Google Maps Autocomplete component
 * @returns {void}
 */
const init = async () => {
  ({ Map, InfoWindow } = await google.maps.importLibrary('maps'));
  ({ AdvancedMarkerElement } = await google.maps.importLibrary('marker'));

  // Initialize the navigation between tabs on mobile
  initTabNavigationOnMobile();

  // Initialize the map
  initMap();

  // Initialize the info window
  initInfoWindow();

  // Initialize the markers
  initMarkers();

  // Set the marker clusterer
  setMarkerClusterer();

  // Set the Google Maps Autocomplete component and its dependencies
  setGoogleMapsAutocomplete();

  // Check the geolocation permissions
  checkGeolocationPermissions();

  // Listen click event on the store details list elements
  listenClickOnStoreDetails();

  // Listen the filter optics checkbox
  listerFilterOptics();

  // Check the URL to filter the optics
  filterOpticsByUrl();

  // Check the URL to focus the store
  focusStoreByUrl();
};

/**
 * Initialize the navigation between tabs on mobile
 * @returns {void}
 */
const initTabNavigationOnMobile = () => {
  element.tabButtons.forEach((tabButton) => {
    listenDOMEvent(tabButton, 'change', function () {
      const value = tabButton.value;

      if (value === VALUE_FOR_TAB_MAP) {
        removeClassToElement(element.page, selector.isVisibleList);
        addClassToElement(element.page, selector.isVisibleMap);
      }

      if (value === VALUE_FOR_TAB_LIST) {
        removeClassToElement(element.page, selector.isVisibleMap);
        addClassToElement(element.page, selector.isVisibleList);
      }
    });
  });
};

/**
 * Set the Google Maps Autocomplete component and its dependencies
 * @returns {void}
 */
const setGoogleMapsAutocomplete = async () => {
  const googleMapsAutocompleteLoader = await initGoogleMapsAutocomplete();

  requestAutocomplete.includedRegionCodes = [
    googleMapsAutocompleteLoader.countryCode
  ];
  requestAutocomplete.language = googleMapsAutocompleteLoader.language;

  googleMapsAutocompleteLoader.loader.load().then(async () => {
    ({ AutocompleteSessionToken, AutocompleteSuggestion } =
      await google.maps.importLibrary('places'));

    listenInputSearch();
    listenCloseSuggestions();
  });
};

/**
 * Refresh the session token for the autocomplete request
 * @returns {void}
 */
const refreshSessionToken = () => {
  sessionAutocomplete.token = new AutocompleteSessionToken();
  sessionAutocomplete.closed = false;
  requestAutocomplete.sessionToken = sessionAutocomplete.token;
};

/**
 * Reset the session token for the autocomplete request
 * @returns {void}
 */
const resetSessionToken = () => {
  sessionAutocomplete.token = null;
  sessionAutocomplete.closed = false;
  requestAutocomplete.sessionToken = null;
  lastPrediction = null;
};

/**
 * Listen the input search events
 * @returns {void}
 */
const listenInputSearch = () => {
  if (element.searcherMap) {
    listenDOMEvent(element.searcherMap, 'input', debouncedHandleInputSearch);
    listenDOMEvent(element.searcherMap, 'focusin', debouncedHandleInputSearch);
    listenDOMEvent(element.searcherMap, 'keydown', handleInputKeyDown);
  }
};

/**
 * Listen the close suggestions list event
 * @returns {void}
 */
const listenCloseSuggestions = () => {
  listenDOMEvent(document, 'click', (event) => {
    if (
      element.suggestions.wrapper &&
      !element.suggestions.wrapper.contains(event.target)
    ) {
      closeSuggestionsList();
    }
  });
};

/**
 * Initialize the map
 * @returns {void}
 */
const initMap = () => {
  map = new Map(element.mapCanvas, {
    scrollwheel: false,
    zoom: 10,
    center: initialLocationForMap,
    mapId: '86db7b10059c4cf3',
    zoomControl: true, // Show the zoom control
    fullscreenControl: false, // Hide the fullscreen control
    mapTypeControl: false, // Hide the map type control
    streetViewControl: false, // Hide the street view control
    rotateControl: false, // Hide the rotate control
    panControl: false // Hide the pan control
  });

  // Update the list items when the bounds change on the map
  map.addListener('bounds_changed', () => {
    clearTimeout(delay);

    delay = setTimeout(function () {
      updateListItems();
    }, 250);
  });
};

/**
 * Initialize the info window
 * @returns {void}
 */
const initInfoWindow = () => {
  infoWindow = new InfoWindow({
    maxWidth: 300
  });

  infoWindow.addListener('closeclick', function () {
    clearSelectedStore();
  });
};

/**
 * Initialize the markers on the map
 * @returns {void}
 */
const initMarkers = () => {
  markers = locations.map((position, i) => {
    let marker = addMarker(position);

    marker.addListener('click', function () {
      clickOnMarker(marker, i);
    });

    return marker;
  });
};

/**
 * Reset the markers on the map and show all of them
 * @returns {void}
 */
const resetMarkersOnMap = () => {
  markers.forEach(function (marker) {
    marker.map = map;
  });

  setMarkerClusterer();
};

/**
 * Set the marker clusterer on the map
 * @returns {void}
 */
const setMarkerClusterer = () => {
  markerCluster = new MarkerClusterer({ markers, map });

  markerCluster.addListener('click', function () {
    clearSelectedStore();
  });
};

/**
 * Check the URL to filter the optics
 * @returns {void}
 */
const filterOpticsByUrl = () => {
  const url = new URL(window.location.href);
  const filterOptics = url.searchParams.get(urlParameter.filterOptics);

  if (element.checkboxOptics && filterOptics === 'true') {
    element.checkboxOptics.checked = true;
    element.checkboxOptics.dispatchEvent(new Event('change'));
  }
};

/**
 * Focus the store that received in the URL
 * @returns {void}
 */
const focusStoreByUrl = () => {
  const url = new URL(window.location.href);
  const storeId = url.searchParams.get('id');
  const storeDetails = document.getElementById(`store-${storeId}`) || null;
  const markerIndex = storeDetails ? storeDetails.dataset.index : null;
  const markerSelected = markerIndex ? markers[markerIndex] : null;

  if (markerSelected) {
    clickOnMarker(markerSelected, markerIndex);
  }
};

/**
 * Create a new marker on the map
 * @param {Object} position - The position of the marker
 * @returns {Marker} The new marker
 */
const addMarker = (position) => {
  let marker = new AdvancedMarkerElement({
    position: { lat: position.latitude, lng: position.longitude },
    content: position.optics
      ? iconMarkerStoreWithOptics.cloneNode(true)
      : iconMarkerStore.cloneNode(true),
    map
  });

  marker.hasOptics = position.optics ? true : false;

  return marker;
};

/**
 * Debounced handle the input search event
 * @param {Event} event - The input search event
 * @returns {void}
 */
const debouncedHandleInputSearch = (event) => {
  const currentValue = element.searcherMap.value.trim();

  if (
    event.type === 'focusin' &&
    currentValue === lastSearchedValueForAutocomplete
  ) {
    return;
  }

  clearTimeout(debounceTimer);

  debounceTimer = setTimeout(() => {
    handleInputSearch();
  }, debounceDelay);
};

/**
 * Handle the input search event
 * @param {Event} event - The input search event
 * @returns {void}
 */
const handleInputSearch = async () => {
  const currentValue = element.searcherMap.value.trim();

  if (currentValue.length >= minCharactersForAutocomplete) {
    if (!requestAutocomplete.sessionToken) {
      refreshSessionToken();
    }
    requestAutocomplete.input = currentValue;

    const suggestions = await getSuggestions();

    currentSuggestions = suggestions;
    lastSearchedValueForAutocomplete = currentValue;
    showSuggestions(suggestions);
  } else {
    closeSuggestionsList();
  }
};

/**
 * Handle the input key down event
 * @param {Event} event - The input key down event
 * @returns {void}
 */
const handleInputKeyDown = (event) => {
  const key = event.key;

  if (key === enterKey) {
    event.preventDefault();
    getSelectedOrFirstPrediction();
  }
};

/**
 * Get the autocomplete suggestions from the input search
 * @returns {Promise<AutocompleteSuggestion[]>} The autocomplete suggestions
 */
const getSuggestions = async () => {
  const { suggestions } =
    await AutocompleteSuggestion.fetchAutocompleteSuggestions(
      requestAutocomplete
    );

  if (suggestions.length > 0) {
    lastPrediction = suggestions[0];
  }

  return suggestions;
};

/**
 * Show the autocomplete suggestions in the suggestions list element
 * @param {AutocompleteSuggestion[]} suggestions - The autocomplete suggestions
 * @returns {void}
 */
const showSuggestions = (suggestions) => {
  const listElements = [];

  suggestions.forEach((suggestion) => {
    const place = suggestion.placePrediction;
    const placeText = place.text;
    const suggestionText = placeText.text;
    const suggestionMatches = placeText.matches;
    const suggestionTextFormatted = formatSuggestionText(
      suggestionText,
      suggestionMatches
    );
    const liElement = createElement({
      tag: 'li',
      content: `&#128205; ${suggestionTextFormatted}`,
      classes: [
        'tw-cursor-pointer',
        'tw-py-2',
        'tw-px-4',
        'tw-text-sm',
        'tw-border-b',
        'tw-border-gray-200',
        'tw-border-dashed',
        'hover:tw-bg-gray-100',
        '[&.is-selected]:tw-bg-gray-100'
      ]
    });

    listenDOMEvent(liElement, 'click', () => {
      onPlaceSelected(place.toPlace());
    });

    listElements.push(liElement);
  });

  paintSuggestions(listElements);
};

/**
 * Format the suggestion text with the highlighted text
 * @param {string} text - The suggestion text
 * @param {object[]} ranges - The highlighted text ranges
 * @returns {string} The formatted suggestion text with the highlighted text
 */
const formatSuggestionText = (text, ranges) => {
  let highlightedText = '';
  let lastIndex = 0;

  ranges.forEach((range) => {
    const { startOffset, endOffset } = range;

    highlightedText += text.slice(lastIndex, startOffset);

    highlightedText += `<strong>${text.slice(startOffset, endOffset)}</strong>`;

    lastIndex = endOffset;
  });

  highlightedText += text.slice(lastIndex);

  return highlightedText;
};

/**
 * Paint the suggestions list with the new content
 * @param {HTMLElement[]} newContent - The new content to paint
 * @returns {void}
 */
const paintSuggestions = (newContent) => {
  if (element.suggestions.list) {
    element.suggestions.list.innerHTML = '';

    newContent.forEach((content) => {
      appendElementContent(element.suggestions.list, content);
    });
  }

  openSuggestionsList();
  handleSuggestionsListNavigation();
};

/**
 * Open the suggestions list element
 * @returns {void}
 */
const openSuggestionsList = () => {
  if (element.suggestions.wrapper) {
    removeClassToElement(element.suggestions.wrapper, classes.hidden);
  }
};

/**
 * Close the suggestions list element
 * @returns {void}
 */
const closeSuggestionsList = () => {
  if (element.suggestions.wrapper) {
    addClassToElement(element.suggestions.wrapper, classes.hidden);
  }
};

/**
 * Handle the suggestions list navigation with the keyboard
 * @returns {void}
 */
const handleSuggestionsListNavigation = () => {
  let currentIndexForSuggestionsList = -1;
  const listItems = element.suggestions.list.querySelectorAll('li');

  if (listItems.length > 0) {
    selectedIndexForSuggestionsList = 0;

    document.addEventListener('keydown', function (event) {
      const eventKey = event.key;

      if (
        eventKey !== 'ArrowDown' &&
        eventKey !== 'ArrowUp' &&
        eventKey !== 'Tab'
      )
        return;

      event.preventDefault();

      if (eventKey === 'ArrowDown') {
        if (currentIndexForSuggestionsList < listItems.length - 1) {
          currentIndexForSuggestionsList++;
        } else {
          currentIndexForSuggestionsList = 0;
        }
      } else if (eventKey === 'ArrowUp') {
        if (currentIndexForSuggestionsList > 0) {
          currentIndexForSuggestionsList--;
        } else {
          currentIndexForSuggestionsList = listItems.length - 1;
        }
      } else if (eventKey === 'Tab') {
        if (currentIndexForSuggestionsList < listItems.length - 1) {
          currentIndexForSuggestionsList++;
        } else {
          currentIndexForSuggestionsList = 0;
        }
      }

      listItems.forEach((item) =>
        removeClassToElement(item, classes.is.selected)
      );

      if (
        currentIndexForSuggestionsList >= 0 &&
        currentIndexForSuggestionsList < listItems.length
      ) {
        addClassToElement(
          listItems[currentIndexForSuggestionsList],
          classes.is.selected
        );
        selectedIndexForSuggestionsList = currentIndexForSuggestionsList;
      }
    });
  }
};

/**
 * Handle the place selected event and fill the address data
 * @param {Place} place - The selected place
 * @returns {void}
 */
const onPlaceSelected = async (place) => {
  closeSuggestionsList();
  clearSelectedStore();

  await place.fetchFields({
    fields: ['formattedAddress', 'location']
  });

  if (element.searcherMap) {
    const chars =
      element.searcherMap.value.trim().length - minCharactersForAutocomplete;

    pushOnDataLayer({
      event: 'google_autocomplete_places',
      chars: chars,
      origin: 'stores'
    });
  }

  const placeLocation = 'location' in place ? place.location : null;
  const latitude = placeLocation ? placeLocation.lat() : '';
  const longitude = placeLocation ? placeLocation.lng() : '';
  const selectedLocation =
    latitude && longitude ? { lat: latitude, lng: longitude } : null;

  // Fill input with the selected address
  element.searcherMap.value = place.formattedAddress;

  // Zoom to the selected location
  if (selectedLocation) {
    zoomToStreetWithClosestMarker(selectedLocation);
  }

  // Reset the session token
  resetSessionToken();
};

/**
 * Get the first prediction from the autocomplete suggestions and handle it
 * @returns {void}
 */
const getSelectedOrFirstPrediction = async () => {
  let suggestions = currentSuggestions;

  // Fallback
  if (suggestions.length === 0) {
    requestAutocomplete.input = element.searcherMap.value.trim();
    suggestions = await getSuggestions();
    currentSuggestions = suggestions;
  }

  if (suggestions.length > 0) {
    const selectedSuggestion = suggestions[selectedIndexForSuggestionsList];
    const place = selectedSuggestion.placePrediction;

    onPlaceSelected(place.toPlace());
  }
};

/**
 * Filter the optics on the map
 * @returns {void}
 */
const filterOpticsOnMap = () => {
  markers.forEach((marker) => {
    if (marker.hasOptics === true) {
      marker.map = map;
    } else {
      markerCluster.removeMarker(marker);
      marker.map = null;
    }
  });
};

/**
 * Show the store details element
 * @param {HTMLElement} element - The store details element
 * @returns {void}
 */
const setVisibleStoreDetails = (element) => {
  removeClassToElement(element, `!${classes.hidden}`);
};

/**
 * Hide the store details element
 * @param {HTMLElement} element - The store details element
 * @returns {void}
 */
const unsetVisibleStoreDetails = (element) => {
  addClassToElement(element, `!${classes.hidden}`);
};

/**
 * Handle the click event on the marker
 * @param {Marker} marker - The marker clicked
 * @param {number} index - The index of the marker
 * @returns {void}
 */
const clickOnMarker = (marker, index) => {
  const storeDetailsSelected = element.storeDetailsElements[index];
  const locationSelected = locations[index];

  clearSelectedStore();

  showInfoWindow(locationSelected.infoWindowHtml, marker);

  addClassToElement(storeDetailsSelected, classes.is.selected);

  // setTimeout(() => {
  //   storeDetailsSelected.scrollIntoView({
  //     alignToTop: false,
  //     block: 'center',
  //     behavior: 'smooth'
  //   });
  // }, 1000);
};

/**
 * Handle the click event on the store details element
 * @param {HTMLElement} store - The store details element
 * @returns {void}
 */
const clickOnStoreDetails = (store) => {
  const index = store.dataset.index;
  const locationSelected = locations[index];
  const markerSelected = markers[index];

  clearSelectedStore();

  showInfoWindow(locationSelected.infoWindowHtml, markerSelected);

  addClassToElement(store, classes.is.selected);
};

/**
 * Clear the selected store details and close the info window
 * @returns {void}
 */
const clearSelectedStore = () => {
  const storeDetailsSelected =
    document.querySelector(`${selector.storeDetails}.${classes.is.selected}`) ||
    null;

  if (storeDetailsSelected) {
    removeClassToElement(storeDetailsSelected, classes.is.selected);
  }

  infoWindow.close();
};

/**
 * Show the info window with the content and the marker
 * @param {string} content - The content to show in the info window
 * @param {Marker} marker - The marker to show the info window
 * @returns {void}
 */
const showInfoWindow = (content, marker) => {
  if (!marker || !marker.position) {
    console.warn('Marker is not available');
    return;
  }

  const position = marker.position.toJSON();

  infoWindow.setContent(content);
  infoWindow.open(map, marker);
  map.setCenter(position);
  map.setZoom(14);

  google.maps.event.addListenerOnce(map, 'idle', () => {
    map.setCenter(position);
    map.setZoom(14);
  });
};

/**
 * Update the list items based on the current map bounds
 * @returns {void}
 */
const updateListItems = () => {
  const currentBounds = map.getBounds();
  markers.forEach(function (marker, index) {
    if (element.checkboxOptics.checked) {
      if (
        currentBounds.contains(marker.position.toJSON()) &&
        locations[index].optics
      ) {
        setVisibleStoreDetails(element.storeDetailsElements[index]);
      } else {
        unsetVisibleStoreDetails(element.storeDetailsElements[index]);
      }
    } else {
      if (currentBounds.contains(marker.position.toJSON())) {
        setVisibleStoreDetails(element.storeDetailsElements[index]);
      } else {
        unsetVisibleStoreDetails(element.storeDetailsElements[index]);
      }
    }
  });
};

/**
 * Check the geolocation permissions
 * @returns {void}
 */
const checkGeolocationPermissions = () => {
  navigator.permissions
    .query({ name: 'geolocation' })
    .then(handleGeolocationPermissions);
};

/**
 * Handle the geolocation permissions and update the geolocation button
 * @param {PermissionStatus} permissionStatus - The geolocation permission status
 * @returns {void}
 */
const handleGeolocationPermissions = (permissionStatus) => {
  updateGeolocationButtonVisibility(permissionStatus.state);

  permissionStatus.onchange = () => {
    updateGeolocationButtonVisibility(permissionStatus.state);
  };
};

/**
 * Update the geolocation button visibility based on the permission status
 * @param {string} state - The permission status
 * @returns {void}
 */
const updateGeolocationButtonVisibility = (state) => {
  if (state === 'granted') {
    enableGeolocationButtonVisibility();
  } else {
    disableGeolocationButtonVisibility();
    adjustMapToCountry();
  }
};

/**
 * Show the geolocation button and listen the click event on it
 * @returns {void}
 */
const enableGeolocationButtonVisibility = () => {
  if (element.buttonGeolocation) {
    removeClassToElement(element.buttonGeolocation, classes.hidden);
    listenDOMEvent(element.buttonGeolocation, 'click', handleGeolocationClick);
    element.buttonGeolocation.dispatchEvent(new Event('click'));
  }
};

/**
 * Hide the geolocation button
 * @returns {void}
 */
const disableGeolocationButtonVisibility = () => {
  console.warn(
    'Geolocation access is blocked. Please enable it in browser settings.'
  );

  if (element.buttonGeolocation) {
    addClassToElement(element.buttonGeolocation, classes.hidden);
  }
};

/**
 * Handle the geolocation click event.
 * Get the user location and adjust the map to it.
 * If the location is not available, adjust the map to the country
 * @returns {void}
 */
const handleGeolocationClick = () => {
  clearSelectedStore();

  navigator.geolocation.getCurrentPosition(
    (position) => {
      const userLocation = {
        lat: position.coords.latitude,
        lng: position.coords.longitude
      };
      adjustMapToLocation(userLocation);
    },
    () => {
      adjustMapToCountry();
    }
  );
};

/**
 * Adjust the map to the current country
 * @returns {void}
 */
const adjustMapToCountry = () => {
  const defaultCountryCode = 'es';
  const countryBounds = {
    es: { lat: 40.4637, lng: -3.7492, zoom: 5 },
    it: { lat: 40.4637, lng: -3.7492, zoom: 5 },
    pt: { lat: 40.4637, lng: -3.7492, zoom: 5 }
  };
  const currentCountryCode = globalVariables.currentCountryCode.toLowerCase();
  const countryData =
    countryBounds[currentCountryCode] || countryBounds[defaultCountryCode];

  map.setCenter({ lat: countryData.lat, lng: countryData.lng });
  map.setZoom(countryData.zoom);
};

/**
 * Adjust the map to the selected location
 * @param {Object} location - The selected location with lat and lng
 * @returns {void}
 */
const adjustMapToLocation = (location) => {
  map.setCenter(location);
  map.setZoom(14);

  google.maps.event.addListenerOnce(map, 'idle', () => {
    const bounds = map.getBounds();
    const markerInView = markers.some((marker) =>
      bounds.contains(marker.position)
    );

    if (!markerInView) {
      recenterMapToNearestMarker(location);
    }
  });
};

/**
 * Zoom the map to the street with the closest marker
 * @param {Object} selectedLocation - The selected location
 * @returns {void}
 */
const zoomToStreetWithClosestMarker = (selectedLocation) => {
  adjustMapToLocation(selectedLocation);

  google.maps.event.addListenerOnce(map, 'bounds_changed', () => {
    if (map.getZoom() > 18) {
      map.setZoom(18);
    }
  });
};

/**
 * Recenter the map to the nearest marker from the selected location
 * @param {Object} newLocation - The selected location
 * @returns {void}
 */
function recenterMapToNearestMarker(newLocation) {
  let nearestMarker = null;
  let nearestDistance = Infinity;
  let visibleMarkers = markers;

  if (element.checkboxOptics.checked) {
    visibleMarkers = markers.filter((marker) => marker.hasOptics);
  }

  visibleMarkers.forEach((marker) => {
    const distance = haversineDistance(newLocation, marker.position);
    if (distance < nearestDistance) {
      nearestDistance = distance;
      nearestMarker = marker;
    }
  });

  if (nearestMarker) {
    const bounds = new google.maps.LatLngBounds();
    bounds.extend(newLocation);
    bounds.extend(nearestMarker.position);
    map.fitBounds(bounds);

    if (map.getZoom() > 15) {
      map.setZoom(15);
    }
  }
}

/**
 * Calculate the haversine distance between two locations
 * @param {Object} loc1 - The first location
 * @param {Object} loc2 - The second location
 * @returns {number} The haversine distance
 */
const haversineDistance = (loc1, loc2) => {
  const R = 6371; // Earth's radius in km
  const dLat = toRadians(loc2.lat - loc1.lat);
  const dLng = toRadians(loc2.lng - loc1.lng);
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(toRadians(loc1.lat)) *
      Math.cos(toRadians(loc2.lat)) *
      Math.sin(dLng / 2) *
      Math.sin(dLng / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

  return R * c;
};

/**
 * Convert degrees to radians
 * @param {number} degrees - The degrees to convert
 * @returns {number} The radians
 */
const toRadians = (degrees) => {
  return (degrees * Math.PI) / 180;
};

/**
 * Listen the click event on the store details elements
 * @returns {void}
 */
const listenClickOnStoreDetails = () => {
  element.storeDetailsElements.forEach((storeDetails) => {
    listenDOMEvent(storeDetails, 'click', () =>
      clickOnStoreDetails(storeDetails)
    );
  });
};

/**
 * Listen the checkbox filter optics event
 * @returns {void}
 */
const listerFilterOptics = () => {
  if (element.checkboxOptics) {
    listenDOMEvent(element.checkboxOptics, 'change', function () {
      if (element.checkboxOptics.checked) {
        filterOpticsOnMap();
      } else {
        resetMarkersOnMap();
      }
    });
  }
};

/**
 * Force close the session with the last prediction to avoid abandoned sessions
 * @returns {void}
 */
const forceCloseSessionWithLastPrediction = async () => {
  if (sessionAutocomplete.token && !sessionAutocomplete.closed) {
    if (lastPrediction) {
      const place = lastPrediction.placePrediction.toPlace();
      await place.fetchFields({ fields: ['formattedAddress', 'location'] });
      sessionAutocomplete.closed = true;
    }

    resetSessionToken();
  }
};

/**
 * Listen the page visibility change event to close open sessions
 * @returns {void}
 */
const listenPageVisibilityChange = () => {
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'hidden') {
      forceCloseSessionWithLastPrediction();
    }
  });
};

// Init
document.addEventListener('DOMContentLoaded', function () {
  init();
  listenPageVisibilityChange();
});
